import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { resolveSidebarMatch } from '@/analytics/context/pageRegistry';

import { buildDocumentTitle } from './documentTitle';
import { useDocumentTitleOverrideValue } from './documentTitleOverride';

/**
 * Keeps `document.title` in sync with the current route and language, so no page has to set
 * it. A page that is not what its route names (not found) overrides it with
 * `useDocumentTitleOverride`.
 */
export function useDocumentTitle(): void {
    const { pathname } = useLocation();
    const { t, i18n } = useTranslation();
    const override = useDocumentTitleOverrideValue();
    const routeTitle = useMemo(
        () => buildDocumentTitle(resolveSidebarMatch(pathname), t),
        // i18n.language re-derives the title when the language changes.
        [pathname, t, i18n.language]
    );
    const title = override ?? routeTitle;

    useEffect(() => {
        document.title = title;
    }, [title]);
}
